import { fetchApiData, updateApiData } from "../../../utils/utils";

export const getAccountDetails = async (appInfo) => {
    const api = "account/details";
    return await fetchApiData(appInfo, api)
}

export const updateAccountdetails = async (appInfo, values) => {

    const api = "user/update";
    const location = {
        path: "accountUpdate",
        values
    }
    return await updateApiData(appInfo, api, location)

}

export const unsubscribe = async (appInfo, subId) => {
    const userId = localStorage.getItem("userId");
    const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
    const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;

    const data = {
        sub_id: subId,
        userid: userId,
        country_code: countryCode,
        pubid: pubId
    }
    const location = {
        path: "common",
        values: data
    }
    const api = "subscription/cancel"
    return await updateApiData(appInfo, api, location)
}

export const undoSubscriptionCancellation = async (appInfo, subId) => {
    const userId = localStorage.getItem("userId");
    const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
    const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
    const data = {
        sub_id: subId,
        userid: userId,
        country_code: countryCode,
        pubid: pubId
    };
    const location = {
        path: "common",
        values: data
    };
    const api = "subscription/cancel/undo";
    try {
        const response = await updateApiData(appInfo, api, location);
        // API returns success: true/false and message
        if (response?.status === 200 && response?.data?.success) {
            return { status: 200, success: true, message: response?.data?.message, subscription: response?.data?.subscription };
        } else if (response?.status === 404) {
            return { status: 404, success: false, message: response?.data?.message || 'No matching subscription found.' };
        } else if (response?.status === 400) {
            return { status: 400, success: false, message: response?.data?.message || 'Undo cancel only supported for Stripe subscriptions.' };
        } else {
            return { status: response?.status || 500, success: false, message: response?.data?.message || 'Failed to undo cancellation.' };
        }
    } catch (error) {
        return { status: 500, success: false, message: error?.message || 'Server error.' };
    }
}

export const pauseSubscription = async (appInfo, subId, pauseDuration) => {
    const userId = localStorage.getItem("userId");
    const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
    const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;

    const data = {
        sub_id: subId,
        userid: userId,
        country_code: countryCode,
        pubid: pubId,
        pauseForMonths: pauseDuration
    }
    const location = {
        path: "common",
        values: data
    }
    const api = "subscription/pause"
    return await updateApiData(appInfo, api, location)
}

export const resumeSubscription = async (appInfo, subId) => {
    const userId = localStorage.getItem("userId");
    const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
    const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;

    const data = {
        sub_id: subId,
        userid: userId,
        country_code: countryCode,
        pubid: pubId
    }
    const location = {
        path: "common",
        values: data
    }
    const api = "subscription/resume"
    return await updateApiData(appInfo, api, location)
}

export const fetchSubscriptionHistory = async (appInfo) => {
    const api = "subscription/history"
    return await fetchApiData(appInfo, api)
}

export const fetchRecentStreamingDevices = async (appInfo) => {
    const api = "account/devices"
    return await fetchApiData(appInfo, api)
}

export const fetchGiftHistory = async (appInfo) => {
    const api = "user/giftTransactions"
    return await fetchApiData(appInfo, api)
}
